"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeTabReducer = changeTabReducer;
var _action_types = require("../../constants/action_types");
var _defaultState = require("./defaultState");
function changeTabReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _action_types.TABS_CHANGE_TAB_TYPE:
      return action.tab;
  }
  return state;
}